import { useEffect, useState } from "react";
import { Modal, Loader } from "components";
import { ReactComponent as WarningIcon } from "icons/warning.svg";
import { getAllUserErrorName } from "utils/gdn_user_error_options";
import { client_v2 } from "utils/api";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import StyledErrorsModal from "./styles";

const ErrorsModal = ({ current_user, packer_id, date, handleClose }) => {
  const [is_loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    getData();
  }, [date, packer_id]);

  const getData = async () => {
    try {
      const res = await client_v2.get(
        `/stats/packer_day_errors?packer_id=${packer_id}&date=${date}`
      );
      const groupedMap = new Map();
      if (res?.data?.length > 0) {
        res.data.forEach((item) => {
          const gdn_id = item.gdn.id;
          const expano_oms_id = item.gdn.expano_oms_id;

          if (!groupedMap.has(gdn_id)) {
            groupedMap.set(gdn_id, {
              gdn_id,
              gdn_expano_oms_id: expano_oms_id,
              company_id: item.company_id,
              items: [],
            });
          }

          groupedMap.get(gdn_id).items.push({
            id: item.id,
            kind: item.kind,
            points: item.points,
            description: item.description,
            gdn_line: item.gdn_line,
            is_created_after_send: item.is_created_after_send,
          });
        });
      }

      const grouped = Array.from(groupedMap.values());

      setData(grouped);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleClose();
      toastr.error("Błąd", "Wystąpił błąd podczas pobierania danych");
    }
  };

  return (
    <Modal
      no_padding
      size="md"
      handleClose={handleClose}
      header={{
        title: `Błędy z dnia ${date || ""}`,
        icon: <WarningIcon />,
      }}
    >
      {is_loading ? (
        <div className="row jc-c p-30">
          <Loader />
        </div>
      ) : (
        <StyledErrorsModal>
          {data?.length > 0 &&
            data.map(({ gdn_id, gdn_expano_oms_id, company_id, items }) => {
              const grouped_skus = items.reduce((acc, item) => {
                const sku = item.gdn_line?.product?.sku || "brak";
                if (!acc[sku]) {
                  acc[sku] = [];
                }
                acc[sku].push({
                  kind: item.kind,
                  is_created_after_send: item.is_created_after_send,
                  description: item.description,
                });

                return acc;
              }, {});

              return (
                <div className="gdn-item" key={gdn_id}>
                  <p class="highlighted">
                    Zamówienie #{gdn_id} (
                    {company_id === 1 ? "Tradecron" : "Wisetrade"})
                  </p>
                  {Number(current_user.company?.id) === Number(company_id) ? (
                    <a
                      target="_blank"
                      href={`/packing/gdn/${gdn_id}`}
                      className="text-link"
                    >
                      Przejdź do zamówienia
                    </a>
                  ) : (
                    <p className="text-danger">
                      Musisz przelogować się na konto{" "}
                      <strong>
                        {company_id === 1 ? "Tradecron" : "Wisetrade"}
                      </strong>{" "}
                      aby podglądnąć zamówienie.
                    </p>
                  )}
                  {["admin", "manager"].includes(current_user.role) && (
                    <p>
                      <a
                        target="_blank"
                        href={`https://tradesk.pl/oms/orders?detail=%22${gdn_expano_oms_id}%22`}
                        className="text-link"
                      >
                        Przejdź do zamówienia OMS
                      </a>
                    </p>
                  )}
                  <div className="gdn-item__panel">
                    {grouped_skus?.["brak"]?.length > 0 && (
                      <>
                        <p className="m-b-5 text-danger">
                          <strong>Błędy zgłoszone w zamówieniu</strong>
                        </p>
                        <ol>
                          {grouped_skus["brak"].map(
                            ({ kind, is_created_after_send, description }) => (
                              <li key={kind}>
                                {is_created_after_send ? (
                                  <div
                                    class="label label--info m-r-5"
                                    style={{ padding: "2px 4px" }}
                                  >
                                    <span class="text-10">Pakowanie</span>
                                  </div>
                                ) : (
                                  <div
                                    class="label label--purple  m-r-5"
                                    style={{ padding: "2px 4px" }}
                                  >
                                    <span class="text-10">Pikowanie</span>
                                  </div>
                                )}
                                {getAllUserErrorName(kind)}{" "}
                                {description ? `- ${description}` : ""}
                              </li>
                            )
                          )}
                        </ol>
                      </>
                    )}
                    {grouped_skus &&
                      Object.keys(grouped_skus).filter((key) => key !== "brak")
                        .length > 0 && (
                        <>
                          <p className="m-b-5 text-danger">
                            <strong>
                              Błędy zgłoszone w pozycjach zamówienia
                            </strong>
                          </p>
                          <ol>
                            {Object.keys(grouped_skus)
                              .filter((key) => key !== "brak")
                              .map((sku) => (
                                <li key={sku}>
                                  <strong>{sku}</strong>
                                  {grouped_skus[sku].map(
                                    ({ kind, is_created_after_send }) => (
                                      <p key={kind}>
                                        {is_created_after_send ? (
                                          <div
                                            class="label label--info m-r-5"
                                            style={{ padding: "2px 4px" }}
                                          >
                                            <span class="text-10">
                                              Pakowanie
                                            </span>
                                          </div>
                                        ) : (
                                          <div
                                            class="label label--purple  m-r-5"
                                            style={{ padding: "2px 4px" }}
                                          >
                                            <span class="text-10">
                                              Pikowanie
                                            </span>
                                          </div>
                                        )}
                                        {getAllUserErrorName(kind)}
                                      </p>
                                    )
                                  )}
                                </li>
                              ))}
                          </ol>
                        </>
                      )}
                  </div>
                </div>
              );
            })}
        </StyledErrorsModal>
      )}
    </Modal>
  );
};

export default connect(({ current_user }) => ({ current_user }))(ErrorsModal);
